import { Loader } from 'lucide-react';

import Avatars from '#/assets/images/LoginAvatars.png';
import Logo from '#/assets/images/logo-h.png';
import { LoginArrow, StarsIcon } from '#/assets/svgs';
import { FieldError } from '#/common/components';
import { PasswordField } from '#/common/components/PasswordField';
import { Button, Input } from '#/components/ui';
import { useLogIn } from '..';

const LogIn = () => {
    const {
        handleChangeLogin,
        handleSubmitLogin,
        loginErrors,
        loginTouched,
        loginValues,
        loginLoading,
        navigateToForgot,
    } = useLogIn();

    return (
        <div className='min-h-screen bg-grid-lines bg-cover bg-center bg-no-repeat flex items-center justify-center px-5 lg:px-[9.25rem]'>
            <div className='relative w-full min-h-[calc(100dvh-67px)] border-lightGray sm:min-h-0 flex flex-col xl:flex-row gap-12 sm:justify-center xl:justify-between items-center max-w-md xl:max-w-[71.5rem] bg-white rounded-2xl shadow-md px-5 sm:px-12 py-14 xl:p-6'>
                <img
                    src={Logo}
                    alt='hill&co'
                    className='w-[10.625rem] xl:absolute top-8 left-8 self-center xl:self-start'
                />
                <div className='flex w-full pt-10 sm:pt-0 flex-col xl:pl-14 gap-8 xl:max-w-[24.375rem]'>
                    <div className='flex flex-col gap-3'>
                        <h2 className='text-secondary font-cormorant text-4xl font-bold'>Welcome back</h2>
                        <p className='text-sm font-normal leading-4 text-gray500'>
                            Welcome back! Please enter your details.
                        </p>
                    </div>

                    <form className='flex flex-col gap-6' onSubmit={handleSubmitLogin}>
                        <div className='space-y-5'>
                            <div className='space-y-2 min-w-[18.5rem] sm:w-[21.875rem] xl:w-[24.3125rem]'>
                                <label htmlFor='email' className='block text-sm font-medium text-gray700'>
                                    Email
                                </label>
                                <Input
                                    id='email'
                                    name='email'
                                    type='email'
                                    className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder:text-sm'
                                    placeholder='Enter your email'
                                    value={loginValues?.email}
                                    onChange={handleChangeLogin}
                                />
                                <FieldError error={loginTouched?.email && loginErrors?.email} />
                            </div>

                            <div className='space-y-2 min-w-[18.5rem] sm:w-[21.875rem] xl:w-[24.3125rem]'>
                                <label htmlFor='password' className='block text-sm font-medium text-gray700'>
                                    Password
                                </label>
                                <PasswordField
                                    id='password'
                                    name='password'
                                    className='w-full h-[2.625rem] px-4 py-3 border border-borderGray rounded-lg shadow-sm placeholder-gray400'
                                    value={loginValues?.password}
                                    onChange={handleChangeLogin}
                                />

                                <FieldError error={loginTouched?.password && loginErrors?.password} />
                            </div>
                        </div>

                        <div className='flex items-center justify-between min-w-[18.5rem] sm:w-[21.875rem] xl:w-[24.3125rem]'>
                            <div className='flex items-center '>
                                <Input
                                    id='rememberMe'
                                    name='rememberMe'
                                    type='checkbox'
                                    value={loginValues?.rememberMe}
                                    onChange={handleChangeLogin}
                                    className='h-4 w-4 border-borderGray rounded cursor-pointer'
                                />
                                <label htmlFor='rememberMe' className='ml-2 block text-sm text-gray600'>
                                    Remember me
                                </label>
                            </div>

                            <div className='text-sm'>
                                <span
                                    onClick={navigateToForgot}
                                    className='font-medium text-sm text-textPrimary cursor-pointer'
                                >
                                    Forgot password
                                </span>
                            </div>
                        </div>

                        <div>
                            <Button
                                type='submit'
                                disabled={loginLoading}
                                className='min-w-[18.5rem] sm:w-[21.875rem] xl:w-[24.3125rem] h-[2.625rem] flex justify-center py-3 px-5 border border-transparent text-sm font-medium rounded-lg cursor-pointer'
                            >
                                {loginLoading ? <Loader className='animate-spin' /> : 'Sign in'}
                            </Button>
                        </div>
                    </form>
                </div>

                <div className='hidden xl:flex w-full bg-login-bg rounded-3xl xl:h-[43.75rem] xl:w-[34.25rem] bg-cover bg-center bg-no-repeat relative'>
                    <div className='relative z-10 flex flex-col gap-2 justify-end items-center self-center px-10 py-16 text-white h-full w-full '>
                        <StarsIcon />
                        <h2 className='text-4xl text-center font-semibold mb-4 leading-snug'>
                            Hill & Co. helps businesses grow smarter with expert strategy and insight.
                        </h2>
                        <img src={Avatars} alt='avatars' />
                        <LoginArrow className='absolute -bottom-5 -left-[18.75rem] z-100' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export { LogIn };
